import React, { useState, useEffect, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import Odometer from 'react-odometerjs';

import CSIO_OurMembers from '../../../assets/CSIO_OurMembers.pdf';

import ReadMore from '../../components/ReadMore';

const OurMembers = () => {


  return (
    <Col>
      <h3 style={{
        textAlign: 'center',
      }}>
        OUR MEMBERS
          </h3>
      <h4
        style={{
          textAlign: 'center',
          marginTop: 20
        }}>
        Across Canada, CSIO is proud to represent:
          </h4>
      <Row>
        <Col>
          <Stat text="INSURERS" number={83} />
          <Stat text="VENDORS" number={43} />
          <Stat text="BROKERS" number={38} k plus/>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 40,
            marginBottom: 20
          }}>
            <ReadMore href={`${CSIO_OurMembers}`} asA/>
          </div>

        </Col>
      </Row>
    </Col>
  )
}

export default OurMembers;

const Stat = ({ number, text, plus, k }) => {
  const [odoVal, setOdoVal] = useState(0);
  const odomRef = useRef(null);

  useEffect(() => {
    const triggerAnimation = () => {
      if (odoVal === 0 && odomRef && odomRef.current && odomRef.current.getBoundingClientRect().top < window.innerHeight) {
        setOdoVal(number);
      };
    }
    window.addEventListener('scroll', triggerAnimation);
    triggerAnimation();
    return () => window.removeEventListener('scroll', triggerAnimation);
  }, [number, odoVal]);

  return (
    <Col>
      <Row ref={odomRef} style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
        letterSpacing: 1.38,
        color: '#F8D564',
        font: "normal normal 800 55px/75px 'Montserrat SemiBold'"
      }}>
        {plus && <span className="odometer-inside">
          +
          </span>}
        <div style={{
          marginTop: -3,
          // border: '1px solid red'
        }}>
          <Odometer
            format="d"
            duration={500}
            value={odoVal}
          />
        </div>

        {k && <span className="odometer-inside">
          k
          </span>}

        <div className="whoWeAreOdometerLabel" style={{ marginLeft: 20 }}>
          {text}
        </div>
      </Row>
    </Col>
  );
}